/**
 * @Description:  全局跳转
 * @Author:  NvDsper
 * @Date: 2026-02-23 11:23:42
 */
export var EGotoType;
(function (EGotoType) {
    EGotoType["login"] = "login";
    EGotoType["personalOpenAccount"] = "personalOpenAccount";
    EGotoType["personalStartAccount"] = "personalStartAccount";
    EGotoType["accountActivation"] = "accountActivation";
    EGotoType["userInformation"] = "userInformation";
    EGotoType["commonWealth"] = "commonWealth";
})(EGotoType || (EGotoType = {}));
const BASE_URL = {
    SIT: 'https://sit.mfosunhani.com',
    UAT: 'https://uat.mfosunhani.com',
    PROD: 'https://h5.mfosunhani.com',
};
const DEFAULT_CONFIG = {
    [EGotoType.login]: {
        sit: BASE_URL.SIT + '/pages/login.html',
        uat: BASE_URL.UAT + '/pages/login.html',
        prod: BASE_URL.PROD + '/pages/login.html',
    },
    [EGotoType.personalOpenAccount]: {
        sit: BASE_URL.SIT + '/pages/openAccount.html',
        uat: BASE_URL.UAT + '/pages/openAccount.html',
        prod: BASE_URL.PROD + '/pages/openAccount.html',
    },
    [EGotoType.personalStartAccount]: {
        sit: BASE_URL.SIT + '/pages/startAccount.html',
        uat: BASE_URL.UAT + '/pages/startAccount.html',
        prod: BASE_URL.PROD + '/pages/startAccount.html',
    },
    [EGotoType.accountActivation]: {
        sit: BASE_URL.SIT + '/portfolios/account/accountActivation',
        uat: BASE_URL.UAT + '/portfolios/account/accountActivation',
        prod: BASE_URL.PROD + '/portfolios/account/accountActivation',
    },
    [EGotoType.userInformation]: {
        sit: BASE_URL.SIT + '/pages/userInformation.html',
        uat: BASE_URL.UAT + '/pages/userInformation.html',
        prod: BASE_URL.PROD + '/pages/userInformation.html',
    },
    [EGotoType.commonWealth]: {
        sit: BASE_URL.SIT + '/wealth/commonOutside.html',
        uat: BASE_URL.UAT + '/wealth/commonOutside.html',
        prod: BASE_URL.PROD + '/wealth/commonOutside.html',
    },
};
/** 本地 devServer（如 http://localhost:8080）使用当前 origin，不跳 sit/uat/prod */
const GOTO_PATH = {
    [EGotoType.login]: '/pages/login.html',
    [EGotoType.personalOpenAccount]: '/pages/openAccount.html',
    [EGotoType.personalStartAccount]: '/pages/startAccount.html',
};
function isLocalDevHost() {
    if (typeof window === 'undefined')
        return false;
    const h = window.location.hostname;
    return h === 'localhost' || h === '127.0.0.1';
}
/** iOS 16 / Safari 16 等无 URL.canParse，行为与标准一致：仅绝对 URL 返回 true */
function urlCanParse(absoluteUrl) {
    const canParse = URL.canParse;
    if (typeof canParse === 'function') {
        return canParse.call(URL, absoluteUrl);
    }
    try {
        new URL(absoluteUrl);
        return true;
    }
    catch {
        return false;
    }
}
export default function goto(url, options) {
    try {
        if (urlCanParse(url)) {
            handleUrl(url, options);
        }
        else if (Object.values(EGotoType).includes(url)) {
            handleCommonScene(url, options);
        }
        else {
            handleRoute(url, options);
        }
    }
    catch (error) {
        console.error(`[goto] ${url} 跳转失败`, error);
        // 未登录等场景必须能进登录页：预设类型再走一次，避免偶发异常导致卡在业务页
        if (Object.values(EGotoType).includes(url)) {
            try {
                handleCommonScene(url, options);
            }
            catch (e2) {
                console.error(`[goto] ${url} 兜底跳转失败`, e2);
            }
        }
    }
}
function handleUrl(url, options) {
    if (options === null || options === void 0 ? void 0 : options.newTab) {
        window.open(url, '_blank');
    }
    else {
        // 同页跳转用 assign，避免部分 iOS WebView 对 window.open(_self) 行为不一致
        window.location.assign(url);
    }
}
function handleCommonScene(url, options) {
    var _a, _b;
    if (!DEFAULT_CONFIG[url]) {
        console.error(`[goto] ${url} 不存在`);
        return;
    }
    let goUrl;
    if (isLocalDevHost()) {
        goUrl = `${window.location.origin}${GOTO_PATH[url]}`;
    }
    else if (process.env.VUE_APP_ENV) {
        goUrl = (_a = DEFAULT_CONFIG[url]) === null || _a === void 0 ? void 0 : _a[process.env.VUE_APP_ENV];
    }
    else {
        goUrl = (_b = DEFAULT_CONFIG[url]) === null || _b === void 0 ? void 0 : _b['prod'];
    }
    let newUrl = new URL(goUrl);
    if (options === null || options === void 0 ? void 0 : options.query) {
        Object.entries(options.query).forEach(([key, value]) => {
            newUrl.searchParams.set(key, value);
        });
    }
    if (options === null || options === void 0 ? void 0 : options.handleUrl) {
        const url = options.handleUrl(newUrl.toString());
        newUrl = new URL(url);
    }
    handleUrl(newUrl.toString(), options);
}
function handleRoute(url, options) {
    var _a, _b;
    const router = options === null || options === void 0 ? void 0 : options.router;
    if (!router) {
        console.error('[goto] router is not defined');
        return;
    }
    if ((options === null || options === void 0 ? void 0 : options.jumpType) === 'replace') {
        router.replace({
            path: url,
            query: options.query,
            params: options.params,
        });
        return;
    }
    router.push({
        path: url,
        query: (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {},
        params: (_b = options === null || options === void 0 ? void 0 : options.params) !== null && _b !== void 0 ? _b : {},
    });
}
/**
 * 将当前 URL 中的参数提取成一个对象
 * @param {string} url - 可选，指定要解析的 URL，默认使用 window.location.href
 * @returns {Object} 返回包含所有查询参数的对象
 * @example
 * // 当前 URL: https://example.com/page?id=123&name=test#/sub?a=1&b=2
 * getUrlParams() // 返回 {id: '123', name: 'test', a: '1', b: '2'}
 * getUrlParams('https://example.com/?x=1&y=2') // 返回 {x: '1', y: '2'}
 */
export function getUrlParams(url = window.location.href) {
    const params = {};
    try {
        const urlObj = new URL(url, window.location.origin);
        // 1. 提取普通查询参数（? 后面的部分）
        const searchParams = new URLSearchParams(urlObj.search);
        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        // 2. 提取 hash 中的查询参数（#/?a=1&b=2 这种形式）
        if (urlObj.hash && urlObj.hash.includes('?')) {
            const hashQuery = urlObj.hash.split('?')[1];
            if (hashQuery) {
                const hashParams = new URLSearchParams(hashQuery);
                for (const [key, value] of hashParams.entries()) {
                    params[key] = value;
                }
            }
        }
    }
    catch (error) {
        console.warn('URL 参数解析失败:', error);
    }
    return params;
}
